import { Component } from "react";
import Layout from "../components/share/Layout";

import {
  SettingService,
  HeaderService,
  SlideService,
  TinTucService,
  GalleryService,
} from "../services";
import { tagContent } from "../util/jqueryUtil";

import { CONTENT } from "../const/content";
import ContentComponent from "../components/share/ContentComponent";
import TopSlide from "../components/index/TopSlide";
import HoatDongVuiHoc from "../components/index/HoatDongVuiHoc";
import { DANH_MUC } from "../const/danh-muc";
import SuKienTrongTuan from "../components/index/SuKienTrongTuan";
import FormDangKy from "../components/index/FormDangKy";
import Video from "../components/index/Video";
import { PageTransition } from "next-page-transitions";
import { SETTING } from "../const/setting";
import SpinnersBigImage from "../components/share/Spinners/SpinnersBigImage";
import SpinnersImage from "../components/share/Spinners/SpinnersImage";
import ThuVienHinhAnhMamNon from "../components/hinh-anh/thu-vien-hinh-anh-mam-non"
import ThuVienHinhAnhPhongThong from "../components/hinh-anh/thu-vien-hinh-anh-pho-thong"
import ThuVienVideo from "../components/hinh-anh/thu-vien-video";

declare const $;

export default class extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      danhSachGalleryVideo: [],
      danhSachGalleryHinhAnh: [],
      activeVideo: false,
    };
  }
  danhSachGalleryVideo;
  danhSachGalleryHinhAnhMamNon;
  danhSachGalleryHinhAnhPhoThong;

  static async getInitialProps() {
    const layoutProps = await Layout.getInitialProps();
    // const title = await SettingService.getSetting(SETTING.title_trang_chu);



    const header = await HeaderService.getsHeader(
      [
        CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN,
        CONTENT.CONTENT_ROYAL_HINHANH_GALLERY_VN,
        CONTENT.CONTENT_ROYAL_HOME_MAP_VN,
        CONTENT.CONTENT_ROYAL_HINH_ANH_MAM_NON_VN,
        CONTENT.CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN,
        CONTENT.CONTENT_ROYAL_VIDEO_VN,
      ],
      []
    );
    const CONTENT_ROYAL_HINHANH_BANNER_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN);
    const CONTENT_ROYAL_HINHANH_GALLERY_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_HINHANH_GALLERY_VN);
    const CONTENT_ROYAL_HOME_MAP_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_HOME_MAP_VN);
    const CONTENT_ROYAL_HINH_ANH_MAM_NON_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_HINH_ANH_MAM_NON_VN);
    const CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN);
    const CONTENT_ROYAL_VIDEO_VN = header.contentValue.find((x) => x.key == CONTENT.CONTENT_ROYAL_VIDEO_VN);
    const title = await SettingService.getSetting(
      SETTING.royal_title_hinh_anh_english
    );


    return {
      title: title.value.value,
      layoutProps,
      CONTENT_ROYAL_HINHANH_BANNER_VN: CONTENT_ROYAL_HINHANH_BANNER_VN.content,
      CONTENT_ROYAL_HINHANH_GALLERY_VN: CONTENT_ROYAL_HINHANH_GALLERY_VN.content,
      CONTENT_ROYAL_HOME_MAP_VN: CONTENT_ROYAL_HOME_MAP_VN.content,
      CONTENT_ROYAL_HINH_ANH_MAM_NON_VN: CONTENT_ROYAL_HINH_ANH_MAM_NON_VN.content,
      CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN: CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN.content,
      CONTENT_ROYAL_VIDEO_VN: CONTENT_ROYAL_VIDEO_VN.content
    };
  }

  componentDidMount() {
    const fragment = window.location.hash.substr(1);
    const elementScrollTo = document.getElementById(fragment);
    if (elementScrollTo) {
      elementScrollTo.scrollIntoView();
    }
    tagContent();
    
  }

  render() {
    return (
      <Layout title={this.props.title} {...this.props.layoutProps}>
        <div>
          <ContentComponent
            content={this.props.CONTENT_ROYAL_HINHANH_BANNER_VN}
          />
          <div>
            <ThuVienHinhAnhMamNon content={this.props.CONTENT_ROYAL_HINH_ANH_MAM_NON_VN}/>
            <ThuVienHinhAnhPhongThong content={this.props.CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN}/>
            <ThuVienVideo content={this.props.CONTENT_ROYAL_VIDEO_VN}/>
          </div>
          <FormDangKy />
          <ContentComponent content={this.props.CONTENT_ROYAL_HOME_MAP_VN} />
        </div>
      </Layout>
    );
  }
}
